import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, Validators, FormGroup, FormArray } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

// SERVICES
import { RolesPermisosService } from "../../../../services/roles_permisos.service";
import { PermisosService } from "../../../../services/permisos.service";
import { RolesService } from "src/app/services/roles.service";

@Component({
  selector: "app-editar-rol",
  templateUrl: "./editar-rol.component.html",
  styleUrls: ["./editar-rol.component.scss"],
})
export class EditarRolComponent implements OnInit {
  selectAllCheckbox: boolean = false;
  counter: number = 0;

  form = this.fb.group({
    // GESTIÓN DE OPERACIONES
    CrearGestióndeOperaciones: [""],
    ConsultarGestióndeOperaciones: [""],
    ActualizarGestióndeOperaciones: [""],
    EliminarGestióndeOperaciones: [""],
    // CASOS
    CrearCasos: [""],
    ConsultarCasos: [""],
    ActualizarCasos: [""],
    EliminarCasos: [""],
    // SAKES
    CrearSakes: [""],
    ConsultarSakes: [""],
    ActualizarSakes: [""],
    EliminarSakes: [""],
    // REGISTRO
    ConsultarRegistro: [""],
    // TIPOS
    CrearTipos: [""],
    ConsultarTipos: [""],
    ActualizarTipos: [""],
    EliminarTipos: [""],
    // VINCULACIÓN DE CASOS SAKES
    ConsultarVinculaciónCasosSakes: [""],
    ActualizarVinculaciónCasosSakes: [""],
    // CUENTAS MAESTRAS
    CrearCuentaMaestra: [""],
    ConsultarCuentaMaestra: [""],
    ActualizarCuentaMaestra: [""],
    EliminarCuentaMaestra: [""],
    // CARGA MASIVA
    CargaMasiva: [""],
    // CRUD USUARIOS
    CrearUsuario: [""],
    ConsultarUsuario: [""],
    ActualizarUsuario: [""],
    EliminarUsuario: [""],
    // ROLES
    CrearRoles: [""],
    ConsultarRoles: [""],
    ActualizarRoles: [""],
    EliminarRoles: [""],
    // CONEXIONES
    ConsultarConexiones: [""],
    ActualizarConexiones: [""],
    // REPORTES
    Reportes: [""],
    Grupos: [""],

    CasosAnalizados: [""],
    Canales: [""],
    Montos: [""],
    CasosDeTodosLosAnalistas: [""],
    CanalesDeTodosLosAnalistas: [""],

    ConsultarSoloMisCasos: [""],
    ValidarCasos: [""],

    // TAREAS PERMISOS
    AdministradorDeTareas:[""],
    AdministradorDeCasos:[""],
    AnalistaDeCasos:[""],

    id_roles: [""],
    nombre: [
      "",
      [
        Validators.required,
        Validators.max(15),
      ],
    ],
    borrado: [0],
    id_usuarios_creador: [sessionStorage.getItem("id_usuario")],
  });
  permisosArray;
  permisos: FormArray;
  permisosForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<EditarRolComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public rolesPermisosService: RolesPermisosService,
    public permisosService: PermisosService,
    private rolesService: RolesService,
    public _snackBar: MatSnackBar
  ) {
    this.setInfo();
    this.permisosService.obtenerTodos().subscribe(async (data: any) => {
      this.permisosArray = data.payload;
      //console.log(this.permisosArray);
      await this.crearFormulario();
      this.permisos = await this.obtenerDataPermisos();
      while (this.obtenerDataPermisos().length) {
        await this.permisos.removeAt(0);
      }
      for (let d of this.permisosArray) {
        await this.agregarPermiso(d);
      }
      this.rolesPermisosService
        .obtenerId(this.data.id_roles)
        .subscribe((data: any) => {
          //console.log(data.payload.data);
          let permisosDelRolArray = [];
          for (let x in data.payload.data) {
            permisosDelRolArray.push(data.payload.data[x].id_permisos);
          }
          for (let i in this.permisosArray) {
            let id_permisosDelFor = this.permisosForm.controls.permisos[
              "controls"
            ][i].controls.id_permisos.value;
            if (permisosDelRolArray.indexOf(id_permisosDelFor) !== -1) {
              this.permisosForm.controls.permisos["controls"][
                i
              ].controls.check.setValue(true);
              this.counter += 1;
            }
          }

          if (this.counter === this.permisosArray.length) {
            this.selectAllCheckbox == true;
          }

          let jsonForm = this.form.value;
          let arrayKeys = [];
          for (let key in jsonForm) {
            if (jsonForm.hasOwnProperty(key)) {
              arrayKeys.push(key);
            }
          }

          for (let x in data.payload.data) {
            //console.log(arrayKeys[data.payload.data[x].id_permisos - 1]);
            this.form.controls[
              arrayKeys[data.payload.data[x].id_permisos - 1]
            ].setValue(true);
          }
        });
    });
  }
  setInfo() {
    this.form.controls.nombre.setValue(this.data.nombre);
    this.form.controls.id_roles.setValue(this.data.id_roles);
    this.rolesPermisosService;
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  ngOnInit() {}
  obtenerDataPermisos() {
    return this.permisosForm.get("permisos") as FormArray;
  }
  agregarPermiso(d) {
    this.obtenerDataPermisos().push(this.construirPermisos(d));
  }
  crearFormulario() {
    this.permisosForm = this.fb.group({
      permisos: this.fb.array([
        this.construirPermisos({
          id_permisos: null,
          nombre: null,
          check: null,
        }),
      ]),
    });
  }

  construirPermisos(data) {
    if (!data) {
      data = {
        id_permisos: null,
        nombre: null,
        check: null,
      };
    }
    return this.fb.group({
      id_permisos: data.id_permisos,
      nombre: data.nombre,
      check: null,
    });
  }

  subirPermisos() {
    let jsonForm = this.form.value;
    let json = this.permisosForm.value;
    let arraydecheckboxes = [];

    for (let key in jsonForm) {
      if (jsonForm.hasOwnProperty(key)) {
        arraydecheckboxes.push(jsonForm[key]);
      }
    }
    for (let x in json.permisos) {
      json.permisos[x].check = false;
    }
    for (let x in json.permisos) {
      if (arraydecheckboxes[x] == true) {
        json.permisos[x].check = true;
      }
    }

    //console.log(json.permisos);

    this.rolesService
      .updateRol(this.form.value.id_roles, this.form.value)
      .subscribe(
        (res) => {
          let json = this.permisosForm.value;
          let body = JSON.stringify(json);
          this.rolesPermisosService
            .actualizar({ permisos: body, id_rol: this.form.value.id_roles })
            .subscribe((data: any) => {
              console.log("Respuesta",data.payload);
              this.openSnackBar("Rol actualizado con éxito.", "X");
              this.dialogRef.close();
            });
        },
        (err) => {
          console.log(err.error.payload);
        }
      );
  }

  selectall(form) {
    this.selectAllCheckbox = !this.selectAllCheckbox;
    for (let i in form) {
      if (
        i === "id_roles" ||
        i == "nombre" ||
        i == "estatus" ||
        i == "borrado" ||
        i == "id_usuarios_creador"
      ) {
        return;
      } else {
        if (this.selectAllCheckbox) {
          this.form.controls[i].setValue(true);
        } else {
          this.form.controls[i].setValue(false);
        }
      }
    }
  }
}
